import { literalUnion } from "diagnostics-lib/io";
import createGlobalState from "@ui/lib/createGlobalState";
import * as io from "io-ts";

export const COLUMNS = [
  "displayName", // only shown if feature flag is on
  "technicalName", // hidden by default, only shown if feature flag is on
  "projectName",
  "projectType",
  "projectSite",
  "setupName",
  "description",
  "unit",
  "degradationType",
  "category",
  "reparability",
  "system",
  "equipmentType",
  "min", // hidden by default
  "max", // hidden by default
  "magnitude", // hidden by default
  "inputModelName", // hidden by default
] as const;

export type Column = (typeof COLUMNS)[number];

const DEFAULT_VISIBLE_COLUMNS: Column[] = [
  "displayName", // only shown if feature flag is on
  "projectName",
  "projectType",
  "projectSite",
  "setupName",
  "description",
  "system",
  "equipmentType",
  "unit",
  "degradationType",
  "category",
  "reparability",
];

export const requiredVisibleColumns: Column[] = ["displayName"];

export const useColumns = createGlobalState({
  storage: "session",
  key: "administrationFailureColumns",
  type: io.array(literalUnion(COLUMNS)),
  defaultValue: DEFAULT_VISIBLE_COLUMNS,
  scoped: false,
});
